// Добавление комментария к УЕ
export const WORKING_DETAILING_ADD_COMMIT = 'WORKING_DETAILING_ADD_COMMIT';
export const WORKING_DETAILING_ADD_COMMIT_SUCCESS = 'WORKING_DETAILING_ADD_COMMIT_SUCCESS';
export const WORKING_DETAILING_ADD_COMMIT_FAIL = 'WORKING_DETAILING_ADD_COMMIT_FAIL';

// Удаление комментария к УЕ
export const WORKING_DETAILING_DEL_COMMIT = 'WORKING_DETAILING_DEL_COMMIT';
export const WORKING_DETAILING_DEL_COMMIT_SUCCESS = 'WORKING_DETAILING_DEL_COMMIT_SUCCESS';
export const WORKING_DETAILING_DEL_COMMIT_FAIL = 'WORKING_DETAILING_DEL_COMMIT_FAIL';

// Получение списка комментариев
export const WORKING_DETAILING_GET_LIST_COMMITS = 'WORKING_DETAILING_GET_LIST_COMMITS';
export const WORKING_DETAILING_GET_LIST_COMMITS_SUCCESS = 'WORKING_DETAILING_GET_LIST_COMMITS_SUCCESS';
export const WORKING_DETAILING_GET_LIST_COMMITS_FAIL = 'WORKING_DETAILING_GET_LIST_COMMITS_FAIL';

// Добавление фото
export const WORKING_DETAILING_ADD_PHOTO = 'WORKING_DETAILING_ADD_PHOTO';
export const WORKING_DETAILING_ADD_PHOTO_SUCCESS = 'WORKING_DETAILING_ADD_PHOTO_SUCCESS';
export const WORKING_DETAILING_ADD_PHOTO_FAIL = 'WORKING_DETAILING_ADD_PHOTO_FAIL';

// Удаление фото
export const WORKING_DETAILING_DEL_PHOTO = 'WORKING_DETAILING_DEL_PHOTO';
export const WORKING_DETAILING_DEL_PHOTO_SUCCESS = 'WORKING_DETAILING_DEL_PHOTO_SUCCESS';
export const WORKING_DETAILING_DEL_PHOTO_FAIL = 'WORKING_DETAILING_DEL_PHOTO_FAIL';

// Список фотографий
export const WORKING_DETAILING_GET_LIST_PHOTOS = 'WORKING_DETAILING_GET_LIST_PHOTOS';
export const WORKING_DETAILING_GET_LIST_PHOTOS_SUCCESS = 'WORKING_DETAILING_GET_LIST_PHOTOS_SUCCESS';
export const WORKING_DETAILING_GET_LIST_FILES_SUCCESS = 'WORKING_DETAILING_GET_LIST_FILES_SUCCESS';
export const WORKING_DETAILING_GET_LIST_PHOTOS_FAIL = 'WORKING_DETAILING_GET_LIST_PHOTOS_FAIL';

// Скачивание фото
export const WORKING_DETAILING_GET_PHOTO_BYTE = 'WORKING_DETAILING_GET_PHOTO_BYTE';
export const WORKING_DETAILING_GET_PHOTO_BYTE_SUCCESS = 'WORKING_DETAILING_GET_PHOTO_BYTE_SUCCESS';
export const WORKING_DETAILING_GET_PHOTO_BYTE_FAIL = 'WORKING_DETAILING_GET_PHOTO_BYTE_FAIL';

// Отправка email
export const WORKING_DETAILING_SEND_EMAIL = 'WORKING_DETAILING_SEND_EMAIL';
export const WORKING_DETAILING_SEND_EMAIL_SUCCESS = 'WORKING_DETAILING_SEND_EMAIL_SUCCESS';
export const WORKING_DETAILING_SEND_EMAIL_FAIL = 'WORKING_DETAILING_SEND_EMAIL_FAIL';
